import apiEndpoints from '../constants/apiEndPoints/authentication';
import { apiHeader } from '../constants/apiHeader';
import { post } from './apiService';

export const authenticateSetNewPassword = async <T>(data: T) => {
  return post(apiEndpoints.SET_NEW_PASSWORD, data, apiHeader.APPLICATION_JSON);
};
